/** Shared suggestion identity; known versions and clean/explicit editions stay separate. */
type Evidence = { title: string; artist_name: string; version?: string; explicit?: boolean | null; isrc?: string | null; recording_id?: string | null }
const normalize = (value: string) => value.normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}_]+/gu, '')
export function recordingKeys(track: Evidence): string[] {
  const version = `${normalize(track.version ?? '')}:${track.explicit ?? false}`
  return [
    ...(track.recording_id ? [`recording:${track.recording_id}`] : []),
    ...(track.isrc ? [`isrc:${normalize(track.isrc)}:${version}`] : []),
    `song:${normalize(track.artist_name)}:${normalize(track.title)}:${version}`,
  ]
}
